import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

import { AuthComponent } from './auth.component';
import { FingerCodeComponent } from './finger-code/finger-code.component';
import { StatementsComponent } from './statements/statements.component';
import { ExitComponent } from './exit/exit.component';

import { AuthGuard } from '../../../core/auth/_guards/auth.guard';
import { ReferencesService } from 'src/app/core/boarding/_services/references.service';
import { ParametersService } from 'src/app/core/boarding/_services/parameters.service';
import { GeneralConfigResolverService } from '../../../core/boarding/_services/_resolvers/general-config-resolver.service';

@NgModule({
  declarations: [
    AuthComponent,
    FingerCodeComponent,
    StatementsComponent,
    ExitComponent
  ],
  exports: [
    FingerCodeComponent,
    StatementsComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: AuthComponent,
        resolve: {
          para: GeneralConfigResolverService
        }
      },
      {
        path: 'redirect',
        component: ExitComponent
      },
    ]),
    MatInputModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatDialogModule
  ]
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        AuthGuard, ReferencesService, ParametersService, GeneralConfigResolverService
      ]
    };
  }
}
